import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { TimeDatePickerComponent } from './time-date-picker.component';
import { MaterialModule } from '@app/material.module';
import { TranslateModule } from '@ngx-translate/core';
import { ReactiveFormsModule } from '@angular/forms';
import { FlexLayoutModule } from '@angular/flex-layout';

@NgModule({
  declarations: [TimeDatePickerComponent],
  imports: [CommonModule, MaterialModule, TranslateModule, FlexLayoutModule, ReactiveFormsModule],
  exports: [TimeDatePickerComponent],
})
export class TimeDatePickerModule {}
